module.exports = __webpack_public_path__ + "static/img/H-R-diagram.6c23647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/H-R-diagram.jpg
// module id = fVLg
// module chunks = 0